import { useDispatch, useSelector } from 'react-redux';
import { updateMilestone } from '../../../../../store/actions/prescriptionPad';
import {
    getMilestones as getMilestonesSelector,
    getPatientPersonalProfile,
    getPrescription,
} from '../../../../../store/selectors/prescriptionPad';
import { MilestoneIcon } from '../../../../common/Icons';
import MilestoneCardV2 from './MilestoneCardV2';
import { IMilestoneHistory } from '../../../../common/types/milestones';
import { UIMilestone } from '../../../../../api/getMilestone';
import moment from 'moment';
import { useEffect, useState } from 'react';
import { getPatientByLocalId } from '../../../../../store/idbHandler';
import { useHistory } from 'react-router-dom';
import { GO_TO_PRESCRIPTION_PAD_V2 } from '../../../../../routes/paths';
import { milestonesUICache } from '../../../../../modules/milestone';
import isEmpty from 'lodash/isEmpty';
import { getIsMilestoneEnabled } from '../../../../../store/selectors/session';
import { track } from '../../../../../tracking';
import { getAgeInYears } from '../../../../../store/utils';

const milestoneIcon = MilestoneIcon();

const MilestoneCard: React.FC = () => {
    const [milestoneData, setMilestoneData] = useState<UIMilestone>({});

    const dispatch = useDispatch();
    const history = useHistory();

    const milestones = useSelector(getMilestonesSelector);
    const patientPersonalProfile = useSelector(getPatientPersonalProfile);

    const [allMilestones, setAllMilestones] = useState<IMilestoneHistory[]>(milestones);

    const px = useSelector(getPrescription);
    const isMilestoneEnabled = useSelector(getIsMilestoneEnabled);

    const [patientDob, setPatientDob] = useState<string>();
    const ageGroups = Object.keys(milestoneData);

    useEffect(() => {
        async function getMilestone() {
            const uiMilestones = await milestonesUICache();
            setMilestoneData(uiMilestones);
        }

        getMilestone();
    }, []);

    useEffect(() => {
        px?.patient.id &&
            getPatientByLocalId(px.patient.id).then((val) => {
                setPatientDob(val.personal.age?.dob);
            });
    }, [px?.patient.id]);

    useEffect(() => {
        setAllMilestones(milestones);
    }, [milestones]);

    const hoursFromBirth = moment().diff(patientDob, 'months') * 730;

    const currAgeGroupIndex = ageGroups.findIndex((ageG) => {
        const milestoneHrs = milestoneData?.[ageG]?.meta?.hrsFromBirth;
        return hoursFromBirth <= milestoneHrs;
    });

    const isEqual = currAgeGroupIndex
        ? milestoneData?.[ageGroups[currAgeGroupIndex]]?.meta?.hrsFromBirth === hoursFromBirth
        : false;

    const currAgeGroupIdx =
        currAgeGroupIndex === 0
            ? currAgeGroupIndex
            : isEqual
            ? currAgeGroupIndex
            : currAgeGroupIndex - 1;

    const currAgeGroup = currAgeGroupIdx < 0 ? ageGroups.length - 1 : currAgeGroupIdx;

    const milestoneDataCurrAge = milestoneData?.[ageGroups[currAgeGroup]];

    const onElementUpdate = (option: IMilestoneHistory) => {
        dispatch(updateMilestone(option));
    };

    const onUpdateAll = () => {
        track('MILESTONE_PAD_GO_TO_SECTION', { pxId: px?.id });
        history.push(GO_TO_PRESCRIPTION_PAD_V2(px?.id ?? '', 'edit', 'milestones'));
    };

    const { age } = patientPersonalProfile || {};
    const ageInYears = getAgeInYears({ dob: age?.dob, month: age?.month });
    const isAbove18 = ageInYears > 18;

    const showMilestoneCard = isMilestoneEnabled && ageInYears && !isAbove18;

    return showMilestoneCard ? (
        <MilestoneCardV2
            icon={milestoneIcon}
            heading={'Growth Milestones'}
            onElementUpdate={onElementUpdate}
            milestones={allMilestones}
            milestoneDataCurrAge={milestoneDataCurrAge}
            currentAgeGroup={ageGroups[currAgeGroup]}
            onUpdateAll={onUpdateAll}
            milestoneData={milestoneData}
            currAgeGroup={currAgeGroup}
        />
    ) : null;
};

export default MilestoneCard;
